import { useEffect } from 'react'
import { Paper, Box } from '@mui/material'
import { useSelector } from 'react-redux'

import { ApplicationState } from '@/state/root.models'
import { useBonusActions, useBonusFilters } from './hooks'
import {
  WageringContributionDialog,
  ExcludedGamesDialog,
  UiBonusesFeedbackComponent,
  BonusesTableComponent,
  BonusFilters,
} from './components'

const BonusEngineModule = () => {
  const { getAllBonuses, setBonusFilters } = useBonusActions()

  const { filters } = useBonusFilters()

  const { brand } = useSelector(({ auth }: ApplicationState) => auth)

  useEffect(() => {
    getAllBonuses(filters)
    return () => {
      setBonusFilters({
        page: 1,
        limit: 25,
      })
    }
  }, []) // eslint-disable-line

  useEffect(() => {
    getAllBonuses(filters)
  }, [brand]) // eslint-disable-line

  return (
    <Box
      component={Paper}
      minHeight="calc(100vh - 168px)"
      display="flex"
      flexDirection="column"
      borderRadius={4}
    >
      <Box p={2}>
        <BonusFilters />
      </Box>
      <BonusesTableComponent />
      <UiBonusesFeedbackComponent />
      <WageringContributionDialog />
      <ExcludedGamesDialog />
    </Box>
  )
}

export default BonusEngineModule
